export const level2Data = {
    catImage:'/images/cats/spiderkitty.png',
    backgroundImage: '/images/backgrounds/level2.JPG',
  nextLevel: '/level3',
   catPosition: {
    x: '85%', 
    y: '55%'  
  },
};
export default level2Data;